<template>
  <Layout>
    <PageHeader title="KMS Video" />

    <div class="kms-video-container">

      <!-- FILTER BAR -->
      <div class="filter-bar">
        <select
          class="form-select filter-select"
          v-model="selectedCategory"
        >
          <option value="">Semua Kategori</option>
          <option
            v-for="cat in categories"
            :key="cat.id"
            :value="String(cat.id)"
          >
            {{ cat.name }}
          </option>
        </select>
      </div>

      <!-- VIDEO GRID -->
      <div class="video-grid">
        <VideoCard
          v-for="video in filteredVideos"
          :key="video.id"
          :video="video"
        />
      </div>

      <!-- EMPTY STATE -->
      <div v-if="!loading && filteredVideos.length === 0" class="empty-state">
        <i class="mdi mdi-video-off-outline"></i>
        <p>Video belum tersedia</p>
      </div>

    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import VideoCard from "./components/VideoCard.vue";
import axios from "axios";

export default {
  components: {
    Layout,
    PageHeader,
    VideoCard,
  },

  data() {
    return {
      loading: true,
      videos: [],
      categories: [],
      selectedCategory: "",
    };
  },

  computed: {
    filteredVideos() {
      if (!this.selectedCategory) return this.videos;
      return this.videos.filter(
        v => String(v.category_id) === this.selectedCategory
      );
    },
  },

  mounted() {
    this.fetchVideos();
    this.fetchCategories();
  },

  methods: {
    authHeader() {
      return {
        Authorization: "Bearer " + localStorage.access_token,
      };
    },

    fetchVideos() {
      axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "master/kms/video",
          { headers: this.authHeader() }
        )
        .then(res => {
          this.videos = res.data.data || [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    fetchCategories() {
      axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "master/kms/video/kategori",
          { headers: this.authHeader() }
        )
        .then(res => {
          this.categories = res.data.data || [];
        });
    },
  },
};
</script>

<style scoped>
.kms-video-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 12px 24px 40px;
}

/* FILTER */
.filter-bar {
  display: flex;
  margin-bottom: 16px;
}

.filter-select {
  width: 280px;
}

/* GRID ala YouTube */
.video-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

/* EMPTY */
.empty-state {
  text-align: center;
  margin-top: 80px;
  color: #999;
}

.empty-state i {
  font-size: 48px;
  margin-bottom: 10px;
}
</style>
